import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatLocation } from '../ai-broker-chat.models';

@Component({
  selector: 'app-chat-location',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="location-card p-3 surface-card border-round-lg border-1 border-gray-300 flex align-items-center gap-3">
      <div class="location-icon bg-primary-faded p-3 border-round-circle">
        <i class="pi pi-map-marker text-primary text-2xl"></i>
      </div>
      <div class="flex-grow-1">
        <div class="font-bold text-900">{{ data().name }}</div>
        <div class="text-sm text-color-secondary">
          {{ data().city }}{{ data().city && data().country ? ', ' : '' }}{{ data().country }}
        </div>
      </div>
      @if (data().latitude && data().longitude) {
        <a [href]="'https://www.google.com/maps/search/?api=1&query=' + data().latitude + ',' + data().longitude" 
           target="_blank" class="p-button p-button-text p-button-rounded p-button-sm">
          <i class="pi pi-external-link"></i>
        </a>
      }
    </div>
  `,
  styles: [`
    .location-card {
      min-width: 280px;
      max-width: 450px;
      margin: 0.5rem 0;
      background: var(--surface-card);
      transition: all 0.2s ease-in-out;
    }
    .location-card:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0,0,0,0.08);
      border-color: var(--primary-color);
    }
    .bg-primary-faded {
      background: rgba(var(--primary-color-rgb, 37, 99, 235), 0.1);
    }
    .location-icon i {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatLocationComponent {
  data = input.required<ChatLocation>();
}
